import { TFunction } from 'i18next';
import { dateTimeFormatter } from '@fides/fides-react-components';

export const getDocumentsColDefs = (t: TFunction, staticData: Record<string, string[]>, displayActiveColumn: boolean) => {
    var columns = [
      {
          headerName: t("document.reportStatus"),
          field: 'active',
          valueGetter: (params: any) => t(params.data && params.data.active ? 'generic.active' : 'generic.inactive'),
          filter: 'agSetColumnFilter',
          filterParams: { values: [t('generic.active'), t('generic.inactive')], defaultToNothingSelected: false },
      },
      {
          headerName: t("document.owner1Type"),
        field: 'owner1Type',
        filter: 'agSetColumnFilter',
        filterParams: { values: staticData.ownerTypes },
      },
      {
          headerName: t("document.documentOwner1"),
            field: 'owner1',
      },
      {
          headerName: t("document.owner2Type"),
            field: 'owner2Type',
        filter: 'agSetColumnFilter',
        filterParams: { values: staticData.ownerTypes },
      },
      {
          headerName: t("document.documentOwner2"),
            field: 'owner2',
      },
      {
          headerName: t("document.reportType"),
            field: 'reportType',
        filter: 'agSetColumnFilter',
        filterParams: { values: staticData.reportTypes },
      },
      {
          headerName: t("document.fileName"),
            field: 'fileName',
      },
      {
          headerName: t("document.createdOn"),
            field: 'creationDate',
        valueFormatter: dateTimeFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            "equals",
            "greaterThan",
            "lessThan",
            "notEqual",
            "inRange",
          ],
        },
          initialSort: 'desc' as const
      },
      {
          headerName: t("document.createdBy"),
            field: 'creatorUsername',
      },
      {
          headerName: t("document.downloadStatus"),
            field: 'status',
        filter: 'agSetColumnFilter',
        filterParams: { values: staticData.downloadStatuses },
      },
      {
          headerName: t("document.downloadedOn"),
            field: 'lastDownloadedOn',
        valueFormatter: dateTimeFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            "equals",
            "greaterThan",
            "lessThan",
            "notEqual",
            "inRange",
          ],
        },
          initialHide: true,
      },
      {
          headerName: t("document.downloadedBy"),
            field: 'lastDownloader',
        valueGetter: (params: any) => params.data && params.data.lastDownloader ? params.data.lastDownloader : '',
        initialHide: true,
      },
      {
          headerName: t("document.fileType"),
            field: 'fileType',
        initialHide: true,
        filter: 'agSetColumnFilter',
        filterParams: { values: staticData.fileTypes },
      },
      {
          headerName: t("document.fileSize"),
            field: 'contentSizeKB',
        valueGetter: (params: any) => params.data.contentSizeKB + ' ' + t('document.KB'),
        initialHide: true,
        filter: 'agNumberColumnFilter',
        filterParams: { filterOptions: null },
      },
  ];

    if (!displayActiveColumn) {
        columns.shift();
    }
    return columns;
}